"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EMateriaAgrupadaCalculo = exports.EMateriaArea = exports.EMateriaOrg = exports.EMateriaGrupo = void 0;
var EMateriaGrupo;
(function (EMateriaGrupo) {
    EMateriaGrupo["Base Nacional Comum"] = "N";
    EMateriaGrupo["Extra Curricular"] = "E";
    EMateriaGrupo["Parte Diversificada"] = "P";
    EMateriaGrupo["Grupo Profissonalizante"] = "F";
})(EMateriaGrupo = exports.EMateriaGrupo || (exports.EMateriaGrupo = {}));
var EMateriaOrg;
(function (EMateriaOrg) {
    EMateriaOrg["Forma\u00E7\u00E3o Geral B\u00E1sica"] = "B";
    EMateriaOrg["Parte Flex\u00EDvel"] = "F";
    EMateriaOrg["Itiner\u00E1rio Formativo"] = "I";
})(EMateriaOrg = exports.EMateriaOrg || (exports.EMateriaOrg = {}));
var EMateriaArea;
(function (EMateriaArea) {
    EMateriaArea["Linguagens e suas Tecnologias"] = "L";
    EMateriaArea["Matem\u00E1tica e suas Tecnologias"] = "M";
    EMateriaArea["Ci\u00EAncias da Natureza e suas Tecnologias"] = "N";
    EMateriaArea["Ci\u00EAncias Humanas e Sociais Aplicadas"] = "H";
})(EMateriaArea = exports.EMateriaArea || (exports.EMateriaArea = {}));
var EMateriaAgrupadaCalculo;
(function (EMateriaAgrupadaCalculo) {
    EMateriaAgrupadaCalculo[EMateriaAgrupadaCalculo["M\u00E9dia Ponderada das SubMat\u00E9ria"] = 0] = "M\u00E9dia Ponderada das SubMat\u00E9ria";
    EMateriaAgrupadaCalculo[EMateriaAgrupadaCalculo["Soma das SubMat\u00E9rias"] = 1] = "Soma das SubMat\u00E9rias";
    EMateriaAgrupadaCalculo[EMateriaAgrupadaCalculo["M\u00E9dia Ponderada e Soma das SubMat\u00E9rias"] = 2] = "M\u00E9dia Ponderada e Soma das SubMat\u00E9rias";
})(EMateriaAgrupadaCalculo = exports.EMateriaAgrupadaCalculo || (exports.EMateriaAgrupadaCalculo = {}));
